export const CilindroTipo = {
  Codigo: null,
  Descripcion: null,
};

export const Desarrollo = {
  Codigo: null,
  Desarrollo: null,
  Engranaje: null,
  Paso: null,
};
export const initialCylinder = {
  CantidadCilindros: null,
  CantidadMagneticos: null,
  CantidadAlmasStamping: null,
  CantidadCilindrosRelieveEnLinea: null,
  Activo: true,
  CilindroTipo,
  Codigo: null,
  CodigoCilindroTipo: null,
  CodigoDesarrollo: null,
  Desarrollo,
};

export const initial_filters = {
  CilindroTipo,
  CantidadCilindros: null,
  CantidadMagneticos: null,
  CantidadAlmasStamping: null,
  CantidadCilindrosRelieveEnLinea: null,
  CodigoDesarrollo: null,
  Activo: true,
};
